var app = angular.module("leonardo");

var ContactListFilters = function(
  $scope,
  ContactTypeRestService,
  PermissionService,
  $controller
) {

  $controller('FiltersBaseController', {$scope: $scope});

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'contact_contact_type',
      name: 'Contact Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Types',
      condition: PermissionService.isOwner(),
      service: ContactTypeRestService,
      conflicts: []
    },
    {
      id: 'contact_name',
      name: 'Contact Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Name contains',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    },
    {
      id: 'contact_email',
      name: 'Contact Email',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Email contains',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    },
    {
      id: 'contact_title',
      name: 'Contact Title',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Title contains',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];

};

app.controller('ContactListFilters', [
  '$scope',
  'ContactTypeRestService',
  'PermissionService',
  '$controller',
  ContactListFilters
]);
